/* @jsx m */
import m from 'mithril';
import iconic from '../vendor/iconic/open-iconic.svg';

export default function Icon() {
  return {
    view: (vnode) => {
      return (
        <svg class="icon" viewBox="0 0 8 8"><use xlink:href={iconic + "#" + vnode.attrs.name} class={"icon-child icon-" + vnode.attrs.name}></use></svg>
      );
    },
  }
}
